import React, { useEffect, useState } from 'react';
import clienteAxios from '../../service/axios';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Titulo2 from '../Dialog/Titulo2'
import Informacion from '../Dialog/Informacion'
///////////////// estilos //////////////////

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
    width: "400px",
    padding:"0px",
    margin:"0px"
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  info: {
    height:"100%",
    textAlign:"center"
  },
}));
/////////////   Variables   /////////////////////



////////////////   Funciones ///////////////////

export default function InfoContacto({ cliente }) {
  const classes = useStyles();
  const [info, setInfo] = useState("")

  const getData = async (x) => {
    let resultado = "";
    let temp = []
    temp = await clienteAxios.get(`/cliente/${x}`);
    if (temp.data) {
      resultado = temp.data.cliente
    }
    return resultado
  }
  useEffect(() => {
    getData(cliente).then(value => setInfo(value))
  }, []);

  return (
    <div className={classes.root}>
      {info &&
        <Grid container >
        <Grid item xs={12} lg={12} md={12}>
              <Titulo2 titulo={"Propietario"} /> 
        </Grid>
        <Grid item xs={12} lg={12} md={12}>
              <Informacion informacion={info.razonSocial}/>
        </Grid>
        <Grid item xs={12} lg={12} md={12}>
              <Titulo2 titulo={"Direccion"} /> 
        </Grid>
        <Grid item xs={12} lg={12} md={12}>
              <Informacion informacion={info.direccion}/>
        </Grid>
        <Grid item xs={12} lg={12} md={12}>
              <Titulo2 titulo={"Telefono"}/>
        </Grid>
          {info.telefono &&
            <Grid item xs={12} lg={12} md={12}>
              {info.telefono.map( tel => {
                return<p>{". (0"+tel.codigoArea+")"+ " - "+tel.numeroTelefono}</p>
              })}
            </Grid>
          }
        </Grid>
      }
    </div>
  )
}